module.exports = __webpack_public_path__ + "img/dcfl03.948c27ae.png";